import { useSelector } from "react-redux";
import { Navigate } from "react-router-dom";
import Layout from "../layout";
import {hasPermission} from '../Hooks/permissionsMiddleware'
import Unauthorized from "../Components/Unauthorized";

// PrivateRoute Component
const PrivateRoute = ({ children, requiredPermissionID }) => {
  // Retrieve the authentication status from Redux store
  const isAuthenticated = useSelector((state) => state.auth.isAuthenticated);

  // Retrieve the user permissions from the Redux store
  const userPermissions = useSelector((state) => state.auth.permissions);
  // If the user is not authenticated, redirect to the login page
  if (!isAuthenticated) {
    return <Navigate to="/" replace />;
  }

  // Check if the user has the necessary permission. 
  // If requiredPermissionID is provided and the user doesn't have it, redirect to the unauthorized page.
  if (requiredPermissionID && !hasPermission(requiredPermissionID)) {
    return <Layout><Unauthorized/></Layout>;
  }

  // If the user is authenticated and has the required permission, render the child components within the Layout.
  return <Layout>{children}</Layout>;
};

export default PrivateRoute;